import {
  ConsumerSpendMultiPolygonRequest,
  ConsumerSpendRadiiRequest,
  ConsumerSpendRadiusData,
  ConsumerSpendResponse,
} from 'src/common-services/types/consumer-spend-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class ConsumerSpendClient extends BaseClient {
  getByRadii(request: ConsumerSpendRadiiRequest): Promise<ConsumerSpendResponse> {
    return this.call<any>('/consumer-spend/by-radii', 'POST', { data: request })
  }

  // TODO(bmc): rename these types to not have radii in them
  getByMultiPolygon(request: ConsumerSpendMultiPolygonRequest): Promise<ConsumerSpendRadiusData> {
    return this.call('/consumer-spend/by-multi-polygon', 'POST', { data: request })
  }
}
